export default "__VITE_ASSET__DnUPhCAJ__"